import React from 'react';
import { truncateText } from '../../../../utils/tranceText';
import { Link } from 'react-router-dom';
import { getTruckTypeColor } from '../../../../helpers/truckTypeColor';
import { formatPhoneNumberWithMask } from '../../../../formatPhoneNumber';

const DriverCardContent = ({ driver }) => {
  return (
    <div className="card-body">
      {/* HEADER */}
      <div className="d-flex align-items-center mb-3">
        <div
          className="mr-3"
          style={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            overflow: 'hidden',
            background: '#f1f3f5',
            flexShrink: 0,
          }}
        >
          {driver.profile_photo ? (
            <img
              src={driver.profile_photo}
              alt="Driver"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              <i className="fa fa-user fa-2x text-secondary" />
            </div>
          )}
        </div>

        <div className="flex-grow-1">
          <div className="fw-bold fs-5">
            {truncateText(driver?.name || 'Unassigned', 26)}
          </div>
          <Link to={`/drivers/${driver.id}`} className="text-decoration-none">
            Driver ID #{driver.id}
          </Link>

          <div className="d-flex flex-wrap gap-2 mt-1">
            {driver.truck_types.map((truck) => (
              <span
                key={truck.id}
                className="badge"
                style={{
                  backgroundColor: getTruckTypeColor(truck.title),
                  color: '#fff',
                }}
              >
                {truck.title}
              </span>
            ))}
            {driver.vehicles.map(({ plate_number }) => (
              <span
                key={plate_number}
                className="badge bg-dark text-white ml-1"
                style={{ textTransform: 'uppercase' }}
              >
                {plate_number}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* INFO */}
      <p className="fw-semibold mb-1">
        {formatPhoneNumberWithMask(driver.phone_num || '', '+9 999 999-9999')}
      </p>
      <p className="text-break mb-0">{truncateText(driver.email || '', 26)}</p>
    </div>
  );
};

export default DriverCardContent;
